// extracted by mini-css-extract-plugin
export default {"bannerButtonDark":"submitButton_bannerButtonDark__PqwRs","bannerButtonLight":"submitButton_bannerButtonLight__Sph5X"};